import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Smartphone, Send } from "lucide-react";
import { PLAY_URL, IMAGES } from "./config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Notify = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/notify`, { email });
      toast.success(data.message || "You have been enlisted, sire.");
      setEmail("");
    } catch {
      toast.error("The ravens failed to deliver. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-testid="notify-section"
      className="relative overflow-hidden py-28 md:py-40"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={IMAGES.mountedKnight}
          alt=""
          className="h-full w-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080808] via-[#080808]/70 to-[#080808]" />
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-accent mb-4 text-xs font-semibold tracking-[0.4em] text-[#D4AF37]">
            JOIN THE REALM
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-[#EAEAEA] md:text-6xl">
            Be first through the gates.
          </h2>
          <p className="mx-auto mt-6 max-w-md text-sm text-[#A3A3A3] md:text-base">
            Leave your raven address and we will summon you the moment
            Ironcrest launches on Google Play.
          </p>

          <form
            onSubmit={submit}
            data-testid="notify-form"
            className="mx-auto mt-10 flex max-w-md flex-col gap-3 sm:flex-row"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@raven.mail"
              data-testid="notify-email-input"
              className="flex-1 rounded-full border border-white/15 bg-black/50 px-6 py-4 text-sm text-[#EAEAEA] placeholder-[#737373] backdrop-blur-xl outline-none transition-colors duration-300 focus:border-[#D4AF37]/60"
            />
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              type="submit"
              disabled={loading}
              data-testid="notify-submit-button"
              className="font-accent flex items-center justify-center gap-2 rounded-full bg-gradient-to-b from-[#E7C65A] to-[#B8912B] px-8 py-4 text-xs font-bold tracking-widest text-[#1A1208] shadow-[0_0_40px_rgba(212,175,55,0.25)] transition-shadow duration-300 hover:shadow-[0_0_60px_rgba(212,175,55,0.45)] disabled:opacity-60"
            >
              <Send className="h-4 w-4" />
              {loading ? "SENDING..." : "NOTIFY ME"}
            </motion.button>
          </form>

          <div className="mt-10 flex justify-center">
            <motion.a
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
              href={PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="notify-play-button"
              className="flex items-center gap-4 rounded-2xl border border-white/15 bg-black/40 px-8 py-4 backdrop-blur-xl transition-colors duration-300 hover:border-[#D4AF37]/50"
            >
              <Smartphone className="h-6 w-6 text-[#D4AF37]" />
              <span className="text-left">
                <span className="font-accent block text-sm font-bold tracking-wider text-[#EAEAEA]">
                  COMING SOON
                </span>
                <span className="block text-xs text-[#A3A3A3]">
                  on Google Play
                </span>
              </span>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
